import React, {useContext} from 'react'
import { Row, Col, Select, DatePicker, Checkbox, Button  } from "antd";
import { locations, newDepartments , getSorted } from '../../util/details';
import { AppContext } from '../../util/context';
import "../../pages/Home/Home.css";
import dayjs from 'dayjs';

const {Option} = Select;

export const FilterModalView = ({
    setModalDetails,
    filterDetails,
    handleFilterChange,
    reviewView,
    current
}) => {
    const {
        StyledDiv
    } = useContext(AppContext)

    return (
        <div className="modal-overlay">
            <Row
                style={{
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    height: "100dvh",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start"
                }}
            >
                <Col 
                
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 22}}
                    xs={{span: 22}}
                    style={{height: "85dvh"}}
                >
                    <div className="modal">
                        <>
                            <Row
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontSize: "22px",
                                        fontWeight: "bold"
                                    }}
                                >
                                    Filters
                                </StyledDiv>
                            </Row>
                            <Row
                                style={{
                                    height: "80%",
                                    overflowY: "scroll",
                                    overflowX: "hidden",
                                    padding: "10px"
                                }}
                            >
                                <Col
                                    span={24}
                                >
                                
                                    {reviewView && current === 'allcards' && <Row
                                        style={{
                                            marginTop: "15px",
                                            marginBottom: "15px"
                                        }}
                                    >
                                        <StyledDiv style={{
                                            fontSize: "13px",
                                            fontWeight: "600"
                                        }}>
                                            <Checkbox 
                                                onChange={(e) => handleFilterChange("readyForClosure", e.target.checked)}
                                                checked={filterDetails.readyForClosure}
                                            >
                                            Cards ready for closure
                                            </Checkbox>
                                        </StyledDiv>
                                    </Row>}

                                    <Row>
                                        <Col
                                            span={10}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Select style={{width: "100%", height: "30px", fontSize: "12px"}}
                                                placeholder="Location"
                                                size='small'
                                                onChange={(value) => handleFilterChange("location", value)}
                                                value={filterDetails.location}
                                            >   
                                                <Option value='none' className="inputText" style={{fontSize: "12px"}}> </Option>
                                                {locations.map((location, index) => (
                                                    <Option key={index} value={location.value} className="inputText" style={{fontSize: "12px"}}>{location.name}</Option>
                                                ))}
                                            </Select>
                                        </Col>

                                        <Col span={2}></Col>

                                        <Col
                                            span={10}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Select style={{width: "100%", height: "30px", fontSize: "12px"}}
                                                placeholder="status"
                                                size='small'
                                                onChange={(value) => handleFilterChange("status", value)}
                                                value={filterDetails.status}
                                            >   
                                                <Option value='none' className="inputText" style={{fontSize: "12px"}}> </Option>
                                                <Option value='open' className="inputText" style={{fontSize: "12px"}}>Open</Option>
                                                <Option value='assigned' className="inputText" style={{fontSize: "12px"}}>Assigned</Option>
                                                {(current === 'allactions' || current === 'myactions') && <Option value='reassigned' className="inputText" style={{fontSize: "12px"}}>Reassigned</Option>}
                                                {(current === 'allactions' || current === 'myactions') && <Option value='completed' className="inputText" style={{fontSize: "12px"}}>Completed</Option>}
                                                <Option value='closed' className="inputText" style={{fontSize: "12px"}}>Closed</Option>
                                                <Option value='void' className="inputText" style={{fontSize: "12px"}}>Void</Option>
                                                
                                            </Select>
                                        </Col>
                                    </Row> 

                                    <Row
                                        style={{
                                            marginTop: "15px"
                                        }}
                                    >
                                        <Col
                                            span={10}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Select style={{width: "100%", height: "30px", fontSize: "12px"}}
                                                placeholder="Business Unit"
                                                size='small'
                                                onChange={(value) => handleFilterChange("department", value)}
                                                value={filterDetails.department}
                                            >   
                                                <Option value='none' className="inputText" style={{fontSize: "12px"}}> </Option>
                                                {getSorted(newDepartments).map((department, index) => (
                                                    <Option key={index} value={department.value} className="inputText" style={{fontSize: "12px"}}>{department.name}</Option>
                                                ))}
                                            </Select>
                                        </Col>

                                        <Col span={12}></Col>
                                    </Row>

                                    <Row
                                        style={{
                                            marginTop: "15px"
                                        }}
                                    >

                                        <Col
                                            span={10}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <DatePicker style={{width: "100%", height: "100%"}}
                                                placeholder='Date From'
                                                className="inputText"
                                                onChange={(date, dateString) => handleFilterChange("dateFrom", dateString)}
                                                value={filterDetails.dateFrom ? dayjs(filterDetails.dateFrom) : null}
                                            />
                                        </Col>
                                        <Col span={2}></Col>

                                        <Col
                                            span={10}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <DatePicker style={{width: "100%"}}
                                                placeholder='Date To'
                                                className="inputText"
                                                onChange={(date, dateString) => handleFilterChange("dateTo", dateString)}
                                                value={filterDetails.dateTo ? dayjs(filterDetails.dateTo) : null}
                                            />
                                        </Col>
                                    </Row>


                                    <Row
                                        style={{
                                            marginTop: "15px"
                                        }}
                                    >
                                        <StyledDiv className="inputText"><label style={{fontSize: "16px", fontWeight: "600"}}> Observation Type</label></StyledDiv>
                                    </Row>  

                                    <Checkbox.Group style={{ width: '100%' }}
                                        onChange={(value) => handleFilterChange("observationType", value)}
                                        value={filterDetails.observationType}
                                    >
                                        <Row
                                            style={{
                                                padding: "15px"
                                            }}
                                            gutter={[0, 16]}
                                        >
                                            <Col 
                                                xl={{span: 8}}
                                                lg={{span: 8}}
                                                md={{span: 8}}
                                                sm={{span: 24}}
                                                xs={{span: 24}}
                                            >
                                                <Checkbox value='Safe Act' className="homeCategoryText"><StyledDiv>Safe Act</StyledDiv></Checkbox>
                                            </Col>

                                            <Col 
                                                xl={{span: 8}}
                                                lg={{span: 8}}
                                                md={{span: 8}}
                                                sm={{span: 24}}
                                                xs={{span: 24}}
                                            >
                                                <Checkbox value='Unsafe Act' className="homeCategoryText"><StyledDiv>Unsafe Act</StyledDiv></Checkbox>
                                            </Col>

                                            <Col 
                                                xl={{span: 8}}
                                                lg={{span: 8}}
                                                md={{span: 8}}
                                                sm={{span: 24}}
                                                xs={{span: 24}}
                                            >
                                                <Checkbox value='Unsafe Condition' className="homeCategoryText"><StyledDiv>Unsafe Condition</StyledDiv></Checkbox>
                                            </Col>
                                        </Row> 
                                    </Checkbox.Group>
                                </Col>
                            </Row>

                            <Row
                                style={{
                                    marginTop: "10px",
                                    paddingTop: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <Button
                                    onClick={() => setModalDetails({show: false, insights: false})}
                                >Close</Button>
                            </Row>
                            
                        
                        </>
                        
                    </div>
                </Col>
            </Row>
            
        </div>
    )
}
